<template>
  <div>
    <vs-divider />
    <h5>Power BI properties</h5>
    <div class="flex flex-col gap-6 mt-4">
      <div class="flex">
        <div class="w-64 flex-shrink-0">
          <span>BI Report Workspace Id</span>
        </div>
        <div class="flex-grow">
          <vs-input v-model="step.workspaceId" class="w-full max-w-sm" />
        </div>
      </div>
      <div class="flex">
        <div class="w-64 flex-shrink-0">
          <span>BI Report Id</span>
        </div>
        <div class="flex-grow">
          <vs-input v-model="step.reportId" class="w-full max-w-sm" />
        </div>
      </div>
      <div class="flex">
        <div class="w-64 flex-shrink-0">
          <span>Apply venue filter to report?</span>
        </div>
        <div class="flex-grow">
          <vs-switch v-model="step.applyVenueFilter" />
        </div>
      </div>
      <div class="flex" v-if="step.applyVenueFilter">
        <div class="w-64 flex-shrink-0">
          <span>Venue filter table</span>
        </div>
        <div class="flex-grow">
          <vs-input v-model="step.venueFilterTable" class="w-full max-w-sm" />
        </div>
      </div>
      <div class="flex" v-if="step.applyVenueFilter">
        <div class="w-64 flex-shrink-0">
          <span>Venue filter column</span>
        </div>
        <div class="flex-grow">
          <vs-input v-model="step.venueFilterColumn" class="w-full max-w-sm" />
        </div>
      </div>
      <div class="flex">
        <div class="w-64 flex-shrink-0">
          <span>Include image of report in email summary?</span>
        </div>
        <div class="flex-grow">
          <vs-switch v-model="step.includeInSummary" />
        </div>
      </div>
    </div>
    <h5 class="mt-4 mb-2">Questions</h5>
    <MeetingStepQuestions :questions="step.questions" />
  </div>
</template>

<script>
import MeetingStepQuestions from "../MeetingStepQuestions.vue";
export default {
  components: {
    MeetingStepQuestions
  },
  props: {
    step: {
      type: Object,
      required: true
    }
  },
  created() {
    this.step.questions = this.step.questions || [];
  }
};
</script>